import { usageTracker, UsageTrackerEvent } from "@volumental/analytic";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { PrivacyBox } from "../../components/accessible-components";
import { useSessionStore } from "../../store";

const RwIds = new Set([
  "e4e24b01-01d6-4e4c-92e3-e60d5ae38fd2",
  "87320875-074d-435e-aaf0-3167fca09194",
  "f020a229-608b-4b3b-abc5-045907427733",
  "f771c4c9-bf3c-461c-9415-7935ce4c1dce",
  "1170e3da-942b-46c3-be4b-fe50494d056e",
  "054af4d0-9084-4626-b7a2-7e7015afb4e3",
  "f0b0ad82-729f-4d90-8bc2-77e155cd593b",
]);

export function PrivacyFooter(): JSX.Element {
  const { token, context } = useSessionStore((store) => store);
  const { t } = useTranslation();
  const isRw = RwIds.has(token);
  return (
    <PrivacyBox
      text={isRw ? t("policyTextRW") : t("policyText")}
      linkText={t("privacyPolicy")}
      link={t("privacyLink")}
      link2={t("termsLink")}
      linkText2={t("termsText")}
      seperatorText={t("and")}
      onClickLink={() => {
        usageTracker.track(UsageTrackerEvent.OpenPrivacyPolicy);
      }}
      limitedBranding={context === "shopify"}
    />
  );
}
